import { actionTypes as bookmakersInfoActionTypes } from './bookmakersInfo.actions';
import cleanStakeInput from '../utils/cleanStakeInput'
import { ERROR_CODES } from '../utils/apiErrors'

const initialState = {
    isEditingStake: false,
    isSuspended: false,
    isSpAvailable: true,
    isLockedStake: false,
    error: {
        errorId: null,
        message: null,
    },
};

/* eslint-disable default-case, consistent-return */
export default (bet, action) => {
    let formattedStake
    let stakeNumber
    let parsed

    switch (action.type) {

        case bookmakersInfoActionTypes.ADD_SELECTED_BET:

            return {
                ...initialState,
                ...action.betInfo,
            }

        case bookmakersInfoActionTypes.SET_STAKE_FOR_SELECTED_BET:

            if (bet.outcomersId !== action.outcomersId) return { ...bet }

            formattedStake = cleanStakeInput(action.stake)
            parsed = parseFloat(formattedStake)
            stakeNumber = isNaN(parsed) ? 0 : parsed

            return {
                ...bet,
                stake: stakeNumber <= 99999.99 ? formattedStake : bet.stake,
            };

        case bookmakersInfoActionTypes.SET_ISEACHWAY_FOR_SELECTED_BET:

            if (bet.outcomersId !== action.outcomersId) return { ...bet }

            return {
                ...bet,
                isEachWay: action.isEachWay,
            };

        case bookmakersInfoActionTypes.SET_PRICE_TYPE_FOR_SELECTED_BET:

            if (bet.outcomersId !== action.outcomersId) return { ...bet }

            return {
                ...bet,
                priceType: action.priceType,
            };

        case bookmakersInfoActionTypes.SET_IS_EDITING_STAKE:

            if (bet.outcomersId !== action.outcomersId) {
                return {
                    ...bet,
                    isEditingStake: false,
                };
            }

            return {
                ...bet,
                isEditingStake: action.isEditingStake,
            };

        case bookmakersInfoActionTypes.SET_ERROR:
        case bookmakersInfoActionTypes.SET_ERROR_ON_BUILD:

            if (bet.outcomersId !== action.outcomersId) return { ...bet }

            return {
                ...bet,
                error: action.error,
            };

        case bookmakersInfoActionTypes.SET_SUSPENDED_BET:
        case bookmakersInfoActionTypes.SET_SUSPENDED_BET_ON_BUILD:

            if (bet.outcomersId !== action.outcomersId) return { ...bet }

            return {
                ...bet,
                isSuspended: action.isSuspended,
            };

        case bookmakersInfoActionTypes.CLEAR_ERROR:

            if (bet.outcomersId !== action.outcomersId) return { ...bet }

            return {
                ...bet,
                error: {
                    errorId: null,
                    message: null,
                },
            };

        case bookmakersInfoActionTypes.SET_PRICE_CHANGED:
        case bookmakersInfoActionTypes.SET_PRICE_CHANGED_ON_BUILD:

            if (bet.outcomersId !== action.outcomersId) return { ...bet }

            return {
                ...bet,
                priceChanged: {
                    decimalPrice: action.decimalPrice,
                    fractionalPrice: action.fractionalPrice,
                },
            };

        case bookmakersInfoActionTypes.UPDATE_BET_PRICE:
            if (bet.outcomersId !== action.outcomersId) return { ...bet }

            return {
                ...bet,
                decimalPrice: action.decimalPrice,
                fractionalPrice: action.fractionalPrice,
                isSpOnly: false,
            };

        case bookmakersInfoActionTypes.UPDATE_ALL_BET_PRICES:
            if (bet.priceChanged === undefined) return { ...bet }

            return {
                ...bet,
                decimalPrice: bet.priceChanged.decimalPrice,
                fractionalPrice: bet.priceChanged.fractionalPrice,
            };

        case bookmakersInfoActionTypes.UPDATE_ALL_STARTING_PRICES_AVAILABILITY:
            if (bet.error.errorId !== ERROR_CODES.STARTING_PRICE_UNAVAILABLE) return { ...bet }

            return {
                ...bet,
                isSpAvailable: false,
                priceType: 'Odds',
            }

        case bookmakersInfoActionTypes.CLEAR_ALL_ERRORS:
            return {
                ...bet,
                error: {
                    errorId: null,
                    message: null,
                },
            }

        case bookmakersInfoActionTypes.TOGGLE_MULTIPLES_INCLUSION:

            if (bet.outcomersId !== action.outcomersId) return { ...bet }

            return {
                ...bet,
                includeInMultiples: action.include,
            }

        case bookmakersInfoActionTypes.SET_MINIMUM_STAKE:

            if (bet.outcomersId !== action.outcomersId) return { ...bet }

            return {
                ...bet,
                associatedBet: {
                    ...bet.associatedBet,
                    minStake: action.minimumStake,
                },
            }

        case bookmakersInfoActionTypes.SET_FREE_BET_MAXIMUM_STAKE:

            if (bet.outcomersId !== action.outcomersId) return { ...bet }

            return {
                ...bet,
                associatedBet: {
                    ...bet.associatedBet,
                    freeBetMaxStake: action.maximumStake,
                },
            }

        case bookmakersInfoActionTypes.SET_FREE_BET_MINIMUM_STAKE:

            if (bet.outcomersId !== action.outcomersId) return { ...bet }

            return {
                ...bet,
                associatedBet: {
                    ...bet.associatedBet,
                    freeBetMinStake: action.minimumStake,
                },
            }

        case bookmakersInfoActionTypes.SET_MAXIMUM_STAKE:

            if (bet.outcomersId !== action.outcomersId) return { ...bet }

            return {
                ...bet,
                associatedBet: {
                    ...bet.associatedBet,
                    maxStake: action.maximumStake,
                },
            }

        case bookmakersInfoActionTypes.SET_LOCKED_STAKE:

            if (bet.outcomersId !== action.outcomersId) return { ...bet }

            return {
                ...bet,
                stake: action.stake,
                isEachWay: false,
                isLockedStake: true,
            }

        case bookmakersInfoActionTypes.CLEAR_LOCKED_STAKE:

            if (bet.outcomersId !== action.outcomersId) return { ...bet }

            return {
                ...bet,
                stake: '',
                isLockedStake: false,
            }
    }
}
/* eslint-enable default-case, consistent-return */



// WEBPACK FOOTER //
// /src/js/common/bookmakersInfo/bookmakersInfo.bets.reducer.js